import NDK, {NDKNip46Signer, NDKPrivateKeySigner} from "@nostr-dev-kit/ndk"

export const ndkInstances = new Map()

export const prepareNdk = ({pubkey, bunkerKey, bunkerToken, bunkerRelay}) => {
  const localSigner = new NDKPrivateKeySigner(bunkerKey)

  const instance = new NDK({
    explicitRelayUrls: bunkerRelay
      ? [bunkerRelay]
      : ["wss://relay.f7z.io", "wss://relay.damus.io", "wss://relay.nsecbunker.com"],
  })

  const nip46Signer = new NDKNip46Signer(instance, pubkey, localSigner)
  /**
   * When a signer can authorize an event via a URL, an authUrl event is emitted.
   */
  nip46Signer.on("authUrl", (url) => {
    const popup = window.open(url, "bunker-auth", "width=600,height=600");

    if (!popup) {
      /**
       * If the popup is blocked, we redirect the user to the auth URL and add a callback URL
       * that will be called with the pubkey generated by the bunker, where we will complete the
       * nip46 authorization (i.e. send a `connect` command)
       */
      const urlObj = new URL(url)

      // Just to ensure we redirect to the root of the app but this could be a "connection successful!" page or something like that
      const selfUrl = new URL(window.location.href)
      selfUrl.pathname = "/"
      urlObj.searchParams.set("callbackUrl", selfUrl.toString());

      // Redirect to the auth URL
      window.location.href = urlObj.toString()
    }
  })

  nip46Signer.token = bunkerToken

  instance.signer = nip46Signer

  instance.connect(5000).then(() => instance.signer.blockUntilReady())

  return instance
}

export const getNdk = session => {
  if (!session?.bunkerKey) {
    return null
  }

  if (!ndkInstances.has(session.pubkey)) {
    ndkInstances.set(session.pubkey, prepareNdk(session))
  }

  return ndkInstances.get(session.pubkey)
}
